export default function LoadingButton({className, label, leadingIcon, trailingIcon, loading, onClick, disabled = false}) {
    return(
        <button className={`${className} ${loading ? 'disabled' : ''} ${!loading ? (leadingIcon ? 'with-icon leading' : (trailingIcon ? 'with-icon trailing' : '')) : ''}`} disabled={disabled} onClick={onClick}>
            {!loading && <>
                {leadingIcon && <span className="material-symbols-outlined scale-xs">{leadingIcon}</span>}
                <span className="showing">{label}</span>
                {trailingIcon && <span className="material-symbols-outlined scale-xs">{trailingIcon}</span>}
            </>} 
            {loading && <span className="material-symbols-outlined spin" style={{translate: '0 -4px'}}>progress_activity</span>}
        </button>
    )
}